// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{grid-template-rows:auto 1fr auto;min-height:100vh}", ""]);
// Exports
module.exports = exports;
